import { useRef, useState } from "react";
import { Link, useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';
import clsx from "clsx";

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from "../../../components/headerBtn/headerBtn";

import ProjectInfo from '../../../pages/projects/projectInfo/projectInfo';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';
import { IUserOptions } from "../../../types/interfaces";

const ProjectInfoSection = () => {
	const { id } = useParams<{ id: string }>();

	const { data } = useSelector((state: any) => state.projects.projects);
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
	const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

	const buttonsContainerRef = useRef<any>(null);

	const [overflowedBtnsCount] = useState<number>(0);
	const [isOpenGroupBtn] = useState<boolean>(false);

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content="Сохранить"
					purpose="1"
					modalTitle="Сохранить"
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content="Вернуться к списку"
					purpose="navigateToProjectsList"
					modalTitle="Возврат к списку проектов"
				/>
			),
		},
	]

	const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);


	const displayedAvailableBtns = filteredAvailableButtons
		?.slice(-(overflowedBtnsCount as number))
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const currentPageTitle =
		data &&
		data.find((el: any) => el?.project?.id === parseFloat(id as string))
			?.project?.name;

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				buttonsContainerRef={buttonsContainerRef}
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={isOpenGroupBtn}
				availableButtons={displayedAvailableBtns}
				title={currentPageTitle && currentPageTitle}
				pageName='projectInfo'
				section='Проекты'
			>
				<div className='content__main'>
					<div className={clsx(
						isOpenSidebar &&
						"btns_active",
						!isOpenSidebar && "btns_close",
						'btns'
					)}>
						<Link to={`/projects/${id}/info`} className='tab'>
							<div className='buttons__btn  --active'>Информация</div>
						</Link>
						{(claims.includes('admin') ||
							claims.includes('projects:routes:list')) && (
								<Link
									to={`/projects/${id}/routes`}
									className='tab'
								>
									<div className='buttons__btn'>Маршруты</div>
								</Link>
							)}
						{(claims.includes('admin') || claims.includes('recruiting:vacancy:view')) &&
						<Link
							to={`/projects/${id}/vacancy`}
							className='tab'
						>
							<div className='buttons__btn'>Вакансии</div>
						</Link>}
					</div>
					<ProjectInfo />
				</div>
			</SectionContent>
		</div>
	);
};

export default ProjectInfoSection;
